import React from "react";
import { Segment } from "semantic-ui-react";

const Loader = (props) => (
  <Segment as="div" className="Loader" basic loading={true} data-cy="Loader" {...props}/>
);

export default Loader;
